import { useState } from 'react';

import { Accordion } from '@change/ds-core-ui/Accordion';
import { Link } from '@change/ds-core-ui/Link';
import { Text } from '@change/ds-core-ui/Text';
import { ArrowRightIcon } from '@change/ds-icons/ArrowRightIcon';
import { CaretDownIcon } from '@change/ds-icons/CaretDownIcon';
import { cn } from '@change/ds-utils';

import { Translate } from '@change-corgi/core-react/i18n';

import { useTipsAndGuides } from './hooks/useTipsAndGuides';

export const TipsAndGuides: React.FC = () => {
	const {
		data: { tips },
		actions: { onTipLinkClick },
	} = useTipsAndGuides();

	const [expanded, setExpanded] = useState(false);

	if (tips.length === 0) return null;

	// Single persistent caret that rotates between states so the change animates
	// via transition-transform: rotate-0 when collapsed, rotate-180 when expanded.
	const caretIcon = (
		<CaretDownIcon
			className={cn(
				'text-icon-strong duration-t4 -mr-px shrink-0 transition-transform ease-out',
				expanded ? 'rotate-180' : 'rotate-0',
			)}
		/>
	);

	return (
		<div className="container">
			<div className="mx-auto max-w-115">
				<Accordion
					variant="contained"
					className="has-[:focus-visible]:ring-stroke-info-strong bg-fill-inverse-strong border-stroke-weak rounded-lg border py-0.5 has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-inset max-md:pb-0 [&_button]:focus-visible:outline-none"
					headingClassName="my-0 h-17 items-center gap-2 bg-fill-inverse-strong group-active:bg-fill-inverse-strong! group-hover:bg-fill-inverse-strong!"
					title={
						<Text fontWeight="bold" className="text-typography-strong group-hover:underline">
							<Translate value="corgi.homepage.how_to_sunrise.tips_and_guides.title" />
						</Text>
					}
					expandIcon={caretIcon}
					collapseIcon={caretIcon}
					onToggle={(_event, isExpanded) => setExpanded(isExpanded)}
					data-qa="homepage-guide-links-list"
				>
					<div className="flex flex-col gap-1 p-1">
						{tips.map((tip) => (
							<Link
								underline={false}
								key={tip.title}
								href={tip.guideLink}
								className="group bg-background-base flex items-center justify-between rounded-[14px] px-5 py-5 no-underline"
								onClick={() => onTipLinkClick(tip.guideLink)}
								data-qa="list-item"
								trailingIcon={
									<ArrowRightIcon className="text-icon-strong duration-t2 shrink-0 transition-transform ease-out group-hover:translate-x-1" />
								}
							>
								<Text variant="body" className="text-typography-strong group-hover:underline">
									{tip.title}
								</Text>
							</Link>
						))}
					</div>
				</Accordion>
			</div>
		</div>
	);
};
